import { render, staticRenderFns } from "./AccountManagementInstructions.pug?vue&type=template&id=763278f5&scoped=true&lang=pug&"
import script from "./AccountManagementInstructions.vue?vue&type=script&lang=js&"
export * from "./AccountManagementInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagementInstructions.scss?vue&type=style&index=0&id=763278f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763278f5",
  null
  
)

export default component.exports